module.exports = __webpack_public_path__ + "img/tab-image-sport-shopAvatar.327489b1.png";